<template lang="pug">
  .w-100.mh-100.h-100
    div(v-if="!reportData.IsSummary")
      .h6 График скорости
      .track_server-chart.row.no-gutters.w-100(v-if="reportData.Data.Data.Points.length > 0")
        .track_chart.col(ref="chart-wrapper")
          D3#reportingSVGd3(v-if="widthSize" ref="d3", :params="paramsChart", :key="keySVG")
      p
    dx-data-grid(ref="grid"
      :data-source='!reportData.IsSummary ? reportData.Data.Data.Rows : reportSummary'
      :selection="{ mode: 'single' }"
      :show-borders='true'
      :style="{ maxHeight: '300px', width: localWidth }"
      :columns="!reportData.IsSummary ? fields.filter(f => f.dataField !== 'ObjectName') : fields"
      :summary="summary"
      :row-alternation-enabled="true"
      :allow-column-reordering="true"
      :allow-column-dragging="false"
      @content-ready="onContentReady"
      @cell-click="onSelectionChanged")
      dx-scrolling(mode='virtual', :useNative="false")
      dx-sorting(mode="multiple")
      dx-load-panel(:enabled="true")
      dx-header-filter(:visible="true")
      dx-grouping(:auto-expand-all="reportData.IsSummary")
</template>
<script>
import { DxDataGrid, DxScrolling, DxPaging, DxHeaderFilter, DxSorting, DxLoadPanel, DxGrouping } from 'devextreme-vue/data-grid';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import dataGridReports from '@/mixins/dataGridReports';
import sizeProps from '@/mixins/sizeProps';
import D3 from '~/components/VueD3';
import { SETTINGS_EVENTS } from '~/consts/eventTypes';

export default {
  name: 'CompetitionViolations',
  components: {
    DxDataGrid,
    DxScrolling,
    DxPaging,
    DxHeaderFilter,
    DxSorting,
    DxLoadPanel,
    DxGrouping,
    D3,
  },
  mixins: [dataGridReports, sizeProps],
  props: {
    reportData: {
      type: Object,
      default () {
        return {};
      },
    },
    track: {
      type: Object,
      default () {
        return {};
      },
    },
    colors: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      fields: [{
        dataField: 'ObjectName',
        caption: 'Объект',
        groupIndex: 0,
      }, {
        dataField: 'RowNum',
        caption: '№',
        fixed: true,
        alignment: 'right',
        width: 50,
      }, {
        dataField: 'TypeText',
        caption: 'Тип',
        alignment: 'center',
        width: 250,
      }, {
        dataField: 'Begin',
        caption: 'Начало',
        alignment: 'center',
        customizeText: params => new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' }),
        width: 120,
      }, {
        dataField: 'End',
        caption: 'Окончание',
        alignment: 'center',
        customizeText: params => new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' }),
        width: 120,
      }, {
        dataField: 'Duration',
        name: 'Duration',
        caption: 'Длительность',
        alignment: 'center',
        width: 110,
      }, {
        dataField: 'AvgSpeed',
        name: 'AvgSpeed',
        caption: 'Средняя скорость',
        alignment: 'center',
        width: 100,
      }, {
        dataField: 'MaxSpeed',
        name: 'MaxSpeed',
        caption: 'Максимальная скорость',
        alignment: 'center',
        width: 100,
      }, {
        dataField: 'Location',
        caption: 'Местоположение',
      }],
      summaryColoumn: [{
        column: 'RowNum',
        displayFormat: 'Итого:',
      }, {
        column: 'Duration',
        name: 'Duration',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'AvgSpeed',
        name: 'AvgSpeed',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'MaxSpeed',
        name: 'MaxSpeed',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }],
      summary: null,
      rowClick: null,
      reportSummary: [],
      periodBounds: null,
      keySVG: 'svgReporting',
      widthSize: null,
    };
  },
  computed: {
    paramsChart () {
      if (this.reportData.IsSummary || !this.widthSize) {
        return {};
      }

      return {
        name: 'reportingChartControl',
        series: {
          id: this.reportData.id,
          axis: [{
            text: 'Скорость',
            name: 'Speed',
            color: '#32A034',
            selected: true,
            groupIndex: 0,
            z: 1,
          }],
        },
        loadDataUrl: '/Reporting/ChartPoints',
        width: this.widthSize - 20,
        height: 500,
        svgName: 'reportingSVG',
      };
    },
  },
  watch: {
    reportData (value) {
      this.rowClick = null;
      this.periodBounds = null;
      if (this.reportData.IsSummary) {
        this.convertSummaryData(this.reportData);
      } else {
        this.getDateType(this.reportData.Data.Data.Points);
      }
      this.getSummary();
      this.updateSVG();
      this.getAddresses();
    },
    widthSize () {
      this.updateSVG();
    },
  },
  created () {
    loadMessages(ruMessages);
    locale('ru');
    if (!this.reportData.IsSummary) {
      this.getDateType(this.reportData.Data.Data.Points);
    }
  },
  mounted () {
    if (this.reportData.IsSummary) {
      this.convertSummaryData(this.reportData);
    } else {
      this.getDateType(this.reportData.Data.Data.Points);
    }
    this.getSummary();
    this.getAddresses();
    this.updateChartWidth();
    this.$eventBus.subscribe(
      SETTINGS_EVENTS.addressSettingsChanged,
      // eslint-disable-next-line no-underscore-dangle
      this._name,
      this.getAddresses,
    );
  },
  beforeDestroy () {
    this.$eventBus.unsubscribe(
      SETTINGS_EVENTS.addressSettingsChanged,
      // eslint-disable-next-line no-underscore-dangle
      this._name,
    );
  },
  updated () {
    this.updateChartWidth();
  },
  methods: {
    updateChartWidth () {
      if (this.$refs['chart-wrapper']) {
        const t = getComputedStyle(this.$refs['chart-wrapper']).width;
        const res = Math.floor(Number(t.substring(0, t.length - 2)));
        this.widthSize = res < 101 ? 101 : res;
      }
    },
    async onSelectionChanged (item) {
      if (item.rowType === 'data') {
        if (this.reportData.BuildTrack && this.track.Id) {
          if (!(this.rowClick && this.rowClick.Begin === item.data.Begin && this.rowClick.End === item.data.End)) {
            const timeZone = Number(this.reportData.TimeZone.split(':', 3)[0]);
            const periods = [[new Date((item.data.Begin - timeZone * 3600) * 1000), new Date((item.data.End - timeZone * 3600) * 1000)]];
            this.periodBounds = await this.$store.dispatch('tracks/updateTrack', { reportId: this.track.Id, secondColor: this.colors.alternative.hex, periods });
            this.reportData.periodsPartTrack = periods;
            this.rowClick = {
              Begin: item.data.Begin,
              End: item.data.End,
            };
          }
        }

        if (['Begin', 'End', 'Location'].includes(item.column.dataField) && ((item.data.LocationLatitude - item.data.LocationLongitude) !== 0)) {
          const value = {
            lat: item.data.LocationLatitude,
            lng: item.data.LocationLongitude,
          };
          this.$store.commit('map/setCenter', value);
          this.$store.commit('tracks/setActivePoint', [value.lat, value.lng]);
        }
      }
    },
    convertSummaryData (data) {
      const rows = [];
      data.Data.Data.forEach((items) => {
        items.Rows.forEach((_row, i) => {
          const row = _row;
          row.RowNum = i + 1;
          row.ObjectName = items.ObjectName;
          rows.push(row);
        });
      });
      this.reportSummary = rows;
    },
    getAddresses () {
      if (this.reportData.State === 'Done' || this.reportData.State === 'OK') {
        if (!this.reportData.IsSummary) {
          this.reportData.Data.Data.Rows.forEach((row) => {
            this.getAddress(row.LocationLatitude, row.LocationLongitude, row);
          });
        } else {
          this.reportData.Data.Data.forEach((obj) => {
            obj.Rows.forEach((row) => {
              this.getAddress(row.LocationLatitude, row.LocationLongitude, row);
            });
          });
        }
      }
    },
    getAddress (lat, lon, _row) {
      const row = _row;
      row.Location = null;
      setImmediate(async () => {
        const address = await this.$store.dispatch('nominatim/getAddress', { lat, lon });
        row.Location = address;
      });
    },

    getDateType (data) {
      data.forEach((x) => {
        const row = x;
        // row.Date = this.convertUTCDateToLocalDate(new Date(x.Timestamp * 1000));
        row.Date = new Date(x.Timestamp * 1000).toLocaleString('ru', { timeZone: 'UTC' });
      });
    },

    convertUTCDateToLocalDate (date) {
      const newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
      const offset = date.getTimezoneOffset() / 60;
      const hours = date.getHours();
      newDate.setHours(hours + offset);
      return newDate;
    },

    updateSVG () {
      this.keySVG = this.keySVG === 'svgReporting' ? 'reloadReportingSVG' : 'svgReporting';
    },
    getSummary () {
      if (!this.reportData.IsSummary) {
        this.summary = {
          calculateCustomSummary: (options) => {
            if (options.summaryProcess === 'finalize') {
              const value = options;
              const totalValue = options.name === 'Duration' ? this.reportData.Data.Data[`Sum${options.name}`] : this.reportData.Data.Data[`${options.name}`].toFixed(2);
              if (totalValue !== undefined) {
                value.totalValue = totalValue;
              }
            }
          },
          totalItems: this.summaryColoumn,
        };
      } else {
        this.summary = {
          calculateCustomSummary: (options) => {
            if (options.summaryProcess === 'finalize') {
              const value = options;
              if (options.groupIndex === undefined) {
                const totalValue = options.name === 'Duration' ? this.reportData.Data[`Sum${options.name}`] : this.reportData.Data[`${options.name}`].toFixed(2);
                if (totalValue !== undefined) {
                  value.totalValue = totalValue;
                }
                this.index = 0;
              } else {
                if (this.reportData.Data.Data[this.index]) {
                  value.totalValue = options.name === 'Duration' ? this.reportData.Data.Data[this.index][`Sum${options.name}`] : this.reportData.Data.Data[this.index][`${options.name}`].toFixed(2);
                }
                if (options.name === 'MaxSpeed') {
                  this.index += 1;
                }
              }
            }
          },
          totalItems: this.summaryColoumn,
          groupItems: this.summaryColoumn.filter(x => x.column !== 'RowNum'),
        };
      }
    },
  },
};
</script>
